import QueryKeys from '@/utils/QueryKeys';
import { plato_api_versions_path } from '@/modules/routes';
import { UseQueryOptions } from '@tanstack/react-query';
import { BaseVersion, ExtraAttributes, VersionSchema } from '@/types/api/v2/VersionSchema';
import useApi from './useApi';

interface UseVersionParams<K extends (keyof BaseVersion)[], E extends (keyof ExtraAttributes)[]> {
  extra_attributes?: E;
  only?: K;
  params?: object;
}

type UseVersionsOptions<K extends (keyof BaseVersion)[], E extends (keyof ExtraAttributes)[]> =
  UseVersionParams<K, E> & Omit<UseQueryOptions<VersionSchema<K[number], E[number]>[]>, 'queryFn' | 'queryKey'>;

export default function useVersions<
  K extends(keyof BaseVersion)[],
  E extends (keyof ExtraAttributes)[],
>({
  extra_attributes = ([] as any as E),
  only,
  params = {},
  ...queryOptions
}: UseVersionsOptions<K, E>) {
  return useApi<VersionSchema<K[number], E[number]>[], BaseVersion, K, ExtraAttributes, E>({
    endpoint: plato_api_versions_path({ extra_attributes, only }),
    extra_attributes,
    only,
    params,
    placeholderData: [],
    queryKey: [QueryKeys.Versions, extra_attributes, only],
    ...queryOptions,
  });
}
